import {Component, OnInit} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import { LoopBackAuth } from '@derena/api';
import {TranslateService} from '@ngx-translate/core';
import {EndpointInterceptor} from '../../../login/endpoint.interceptor';

@Component({
    selector: 'app-topnav',
    templateUrl: './topnav.component.html',
    styleUrls: ['./topnav.component.scss']
})
export class TopnavComponent implements OnInit {
    pushRightClass: string;
    title: string;

    constructor(public router: Router, private translate: TranslateService, private endpoint: EndpointInterceptor, private authService: LoopBackAuth) {
        this.router.events.subscribe(val => {
            if (val instanceof NavigationEnd && window.innerWidth <= 2500 && this.isToggled()) {
                this.toggleSidebar();
            }
        });
    }

    ngOnInit() {
        this.pushRightClass = 'push-right';
        this.title = this.endpoint.name;
        this.endpoint
            .changes()
            .subscribe(
                x => this.title = x.name
            )
    }

    isToggled(): boolean {
        const dom: Element = document.querySelector('body');
        return dom.classList.contains(this.pushRightClass);
    }

    toggleSidebar() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle(this.pushRightClass);
    }

    onLoggedOut() {
        this.authService.clear();
        localStorage.removeItem('auth');
        this.router.navigate(['/login']);
    }

    changeLang(language: string) {
        this.translate.use(language);
    }

    goToSettings(){
        this.router.navigate(['/settings']);
    }
}
